import type { Message } from '@/features/messages/models/message';
import { Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import type { FC } from 'react';

interface MessageMenuDateDisplayProps {
  message: Message;
}

export const MessageMenuDateDisplay: FC<MessageMenuDateDisplayProps> = ({ message }) => {
  return (
    <Stack direction='row' alignItems='center' justifyContent='center' sx={{ py: 1 }}>
      <Typography variant='caption'>{dayjs(message.sentAt).format('HH:mm DD/MM/YYYY')}</Typography>
    </Stack>
  );
};
